import React from 'react';
import './Contact.css';
import emailImage from '../assets/email_address.png';
import wechatQr from '../assets/wechat_qr.png';

function Contact({ language }) {
  const texts = {
    zh: {
      eyebrow: 'CONTACT / COLLABORATION',
      title: '联系我们',
      subtitle: '与游戏与艺术创研中心建立连接',
      intro: '如果你希望了解中心项目、活动、研究合作、媒体联络或加入相关工作，欢迎通过以下方式联系。我们会根据事项类型转交给合适的老师或项目成员。',
      emailLabel: '邮箱',
      emailDesc: '合作咨询、活动沟通、媒体联络与一般事务',
      wechatLabel: '微信',
      wechatDesc: '扫码或添加联系人，适合活动咨询与即时沟通',
      wechatPlaceholder: 'WECHAT QR',
      appointmentLabel: '到访预约',
      appointmentDesc: '如需线下拜访、访谈或会议，请提前通过邮件说明来访目的与时间。',
      cooperationTitle: '联系事项',
      cooperationItems: [
        '学术合作与联合研究',
        '讲座、工作坊与活动共创',
        '媒体采访与品牌合作',
        '学生参与、志愿者机会',
        '国际交流与机构网络'
      ],
      noteTitle: '发送邮件时建议包含',
      noteItems: ['姓名与所在机构', '联系方式', '希望沟通的事项', '预计时间或合作形式'],
      responseLabel: '回复节奏',
      responseText: '一般会在3-7工作日回复。',
      copyEmail: '复制邮箱',
      mailNow: '发送邮件'
    },
    en: {
      eyebrow: 'CONTACT / COLLABORATION',
      title: 'Contact Us',
      subtitle: 'Connect with the PKU Game and Art Research Center',
      intro: 'For inquiries about programs, events, research collaboration, media requests, or participation opportunities, please contact us through the channels below.',
      emailLabel: 'Email',
      emailDesc: 'General inquiries, collaboration, events, and media contact',
      wechatLabel: 'WeChat',
      wechatDesc: 'Scan or add the contact for event-related communication',
      wechatPlaceholder: 'WECHAT QR',
      appointmentLabel: 'Visit by appointment',
      appointmentDesc: 'For visits, interviews, or meetings, please email us in advance with your purpose and preferred time.',
      cooperationTitle: 'Inquiry Topics',
      cooperationItems: [
        'Academic collaboration and joint research',
        'Lectures, workshops, and event co-creation',
        'Media interviews and institutional partnership',
        'Student participation and volunteering',
        'International exchange and research networks'
      ],
      noteTitle: 'Please include',
      noteItems: ['Name and affiliation', 'Contact information', 'Inquiry topic', 'Expected time or collaboration format'],
      responseLabel: 'Response',
      responseText: 'We usually reply within 3-7 working days.',
      copyEmail: 'Copy Email',
      mailNow: 'Email Us'
    }
  };

  const currentTexts = texts[language] || texts.en;
  const emailParts = ['zackus', 'pku.edu.cn'];
  const getEmail = () => `${emailParts[0]}@${emailParts[1]}`;

  const copyEmail = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(getEmail());
    }
  };

  const openEmail = () => {
    window.location.href = `mailto:${getEmail()}`;
  };

  return (
    <section className="contact-page" id="contact">
      <div className="contact-shell">
        <section className="contact-hero">
          <div className="contact-hero-copy">
            <div className="contact-eyebrow">{currentTexts.eyebrow}</div>
            <h1 className="contact-title">{currentTexts.title}</h1>
            <p className="contact-subtitle">{currentTexts.subtitle}</p>
            <p className="contact-intro">{currentTexts.intro}</p>
            <div className="contact-actions">
              <button className="contact-action primary" type="button" onClick={openEmail}>
                {currentTexts.mailNow}
              </button>
              <button className="contact-action" type="button" onClick={copyEmail}>
                {currentTexts.copyEmail}
              </button>
            </div>
          </div>
          <div className="contact-signal-panel" aria-hidden="true">
            <div className="signal-ring"></div>
            <div className="signal-core">A&amp;G</div>
            <div className="signal-readout">ONLINE</div>
          </div>
        </section>

        <div className="contact-layout">
          <section className="contact-channel-grid">
            <article className="contact-card contact-email-card">
              <div className="contact-card-index">01</div>
              <div>
                <h2>{currentTexts.emailLabel}</h2>
                <button className="contact-email-button" type="button" onClick={copyEmail} aria-label={currentTexts.copyEmail}>
                  <img className="contact-email-image" src={emailImage} alt="" />
                </button>
                <p>{currentTexts.emailDesc}</p>
              </div>
            </article>

            <article className="contact-card contact-wechat-card">
              <div className="contact-card-index">02</div>
              <div className="wechat-card-content">
                <div>
                  <h2>{currentTexts.wechatLabel}</h2>
                  <p>{currentTexts.wechatDesc}</p>
                </div>
                <div className="wechat-qr-frame">
                  <img src={wechatQr} alt={currentTexts.wechatLabel} />
                </div>
              </div>
            </article>

            <article className="contact-card contact-appointment-card">
              <div className="contact-card-index">03</div>
              <div>
                <h2>{currentTexts.appointmentLabel}</h2>
                <p>{currentTexts.appointmentDesc}</p>
              </div>
            </article>
          </section>

          <aside className="contact-side-panel">
            <div className="side-panel-block">
              <h2>{currentTexts.cooperationTitle}</h2>
              <div className="contact-topic-list">
                {currentTexts.cooperationItems.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
            </div>

            <div className="side-panel-block">
              <h2>{currentTexts.noteTitle}</h2>
              <ul className="contact-note-list">
                {currentTexts.noteItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="contact-response-strip">
              <strong>{currentTexts.responseLabel}</strong>
              <span>{currentTexts.responseText}</span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default Contact;
